import { DYNAMIC_TILE_SERVER } from 'src/app/featureToggles';
import { useConfigSelectors } from 'src/app/reducers';

export const useIsDynamicTileServer = () => {
  const configSelectors = useConfigSelectors();
  return configSelectors.isFeatureAvailable(DYNAMIC_TILE_SERVER);
};
